'use strict'

module.exports = trimLines

var ws = /[ \t]*\n+[ \t]*/g
var newline = '\n'

function trimLines(value) {
  return String(value).replace(ws, newline)
}



//////////////////
// WEBPACK FOOTER
// ./~/trim-lines/index.js
// module id = 2234
// module chunks = 2